import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import TrackingLink from 'Layout/NavBar/MegaMenu/Categories/TrackingLink';

export default function SportsRacingLinks({ setMegaMenuTab }) {
  return (
    <ul className="CategoriesMegaMenu__linksContainer" role="menu">
      <li className="CategoriesMegaMenu__link">
        <TrackingLink to="/categories/sports-and-racing" id="categories-sportsandracing" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="sports-racing-links.link.sports-and-racing" defaultMessage="Sports and Racing" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/all-individual-sports" id="categories-allindividualsports" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="sports-racing-links.link.all-individual-sports" defaultMessage="All Individual Sports" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/all-team-sports" id="categories-allteamsports" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="sports-racing-links.link.all-team-sports" defaultMessage="All Team Sports" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/basketball" id="categories-basketball" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="sports-racing-links.link.basketball" defaultMessage="Basketball" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/fishing-and-hunting" id="categories-fishingandhunting" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="sports-racing-links.link.fishing-and-hunting" defaultMessage="Fishing and Hunting" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/golf" id="categories-golf" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="sports-racing-links.link.golf" defaultMessage="Golf" />
        </TrackingLink>
      </li>
      <li className="CategoriesMegaMenu__link CategoriesMegaMenu__link--sublink">
        <TrackingLink to="/categories/racing" id="categories-racing" setMegaMenuTab={setMegaMenuTab}>
          <FormattedMessage id="sports-racing-links.link.racing" defaultMessage="Racing" />
        </TrackingLink>
      </li>
    </ul>
  );
}

SportsRacingLinks.propTypes = {
  setMegaMenuTab: PropTypes.func,
};

SportsRacingLinks.defaultProps = {
  setMegaMenuTab: () => { },
};
